var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephoneKeySystem01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.31,10.49H1.78V4.16h12.53V10.49z M2.28,9.99h11.53V4.66H2.28V9.99z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3.63,8.99V5.67h0.44v1.65l1.65-1.65h0.6L4.92,7.01l1.45,1.97H5.8L4.61,7.31L4.07,7.84v1.15H3.63z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.59,7.92l0.42-0.04c0.02,0.17,0.07,0.3,0.14,0.41s0.18,0.19,0.33,0.26c0.15,0.07,0.32,0.1,0.51,0.1 c0.17,0,0.32-0.03,0.44-0.08c0.13-0.05,0.22-0.12,0.29-0.21c0.06-0.09,0.09-0.18,0.09-0.28c0-0.1-0.03-0.2-0.09-0.27 c-0.06-0.08-0.16-0.14-0.3-0.2C8.33,7.58,8.14,7.53,7.83,7.45C7.52,7.38,7.31,7.31,7.19,7.25C7.03,7.16,6.91,7.06,6.84,6.94 C6.76,6.82,6.72,6.68,6.72,6.52c0-0.17,0.05-0.32,0.14-0.47C6.96,5.91,7.1,5.8,7.28,5.72c0.18-0.08,0.39-0.11,0.61-0.11 c0.25,0,0.46,0.04,0.65,0.12c0.19,0.08,0.33,0.2,0.43,0.35c0.1,0.15,0.16,0.33,0.16,0.52L8.71,6.63c-0.02-0.21-0.1-0.37-0.23-0.48 C8.35,6.05,8.16,6,7.9,6C7.64,6,7.45,6.05,7.32,6.14C7.2,6.24,7.14,6.36,7.14,6.5c0,0.12,0.04,0.22,0.13,0.29 c0.08,0.08,0.31,0.16,0.66,0.24c0.36,0.08,0.6,0.15,0.74,0.21C8.86,7.33,9,7.44,9.1,7.58c0.09,0.14,0.14,0.29,0.14,0.47 c0,0.18-0.05,0.34-0.15,0.5S8.84,8.83,8.65,8.91s-0.4,0.13-0.64,0.13c-0.3,0-0.55-0.04-0.76-0.13c-0.2-0.09-0.36-0.22-0.48-0.39 S6.6,8.14,6.59,7.92z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.01,5.67h0.44v1.92c0,0.33-0.04,0.6-0.11,0.79s-0.21,0.36-0.41,0.48c-0.2,0.12-0.46,0.18-0.78,0.18 c-0.31,0-0.57-0.05-0.76-0.16c-0.2-0.11-0.34-0.26-0.42-0.46c-0.08-0.2-0.13-0.48-0.13-0.83V5.67h0.44v1.92 c0,0.29,0.03,0.5,0.08,0.64c0.05,0.14,0.15,0.24,0.28,0.32c0.13,0.07,0.29,0.11,0.48,0.11c0.32,0,0.55-0.07,0.69-0.22 S12.01,8,12.01,7.58V5.67z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephoneKeySystem01);
export default __webpack_public_path__ + "static/media/TelephoneKeySystem-01.ddf9f5d3e7e2abc6be1ae0c8f7afdde3.svg";
export { ForwardRef as ReactComponent };